import { pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const btnToggleExpanded = css`
  margin-top: ${pxToRem(spacing.md)};
  text-align: left;
`;
